export default {
  async init({ commit, dispatch }) {
    if (this.$device && this.$device.isMobile) {
      commit('SET_IS_MOBILE');
    }

    await dispatch('processApplication');
  },
  setSidebarDrawer({ commit }, value) {
    commit('SET_SIDEBAR_DRAWER', value);
  },

  // v3
  async processApplication({ commit, rootState }) {
    const hostname = rootState.hostname;

    const settings = await this.$services._core.applicationV3().getApplicationSettingsByHostname(hostname);

    commit('SET_THEMES', settings.theme);
    commit('SET_LOGO', settings.theme);

    const { tenant, institution, owner } = settings;

    commit('_core/tenant/SET_TENANT', tenant, { root: true });
    commit('_core/tenant/SET_INSTITUTION', institution, { root: true });

    commit('SET_IS_OPERATION', owner === null);
    commit('SET_OWNER', owner);

    // Legacy
    commit('SET_CREATE_ACCOUNT', false);
  }
};
